export enum TabNameEnum {
  CHANGE_LOG = 'change-log',
  AIRCRAFT_LIST = 'aircraft-list',
  AIRCRAFT_PART_135 = 'part-135',
  AIRCRAFT_UPLOAD = 'aircraft-upload',
  AIRCRAFT = 'aircraft',
  ORGANIZATION = 'organization',
  AIRCRAFT_PRICES = 'prices',
  FLOOR_PLAN = 'floor-plan',
}
